import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { get, round } from 'lodash-es';

import CurrencyNumberFormat from '../../Common/CurrencyNumberFormatComponent';

const SummaryLoan = props => {
  const { loans, strings, kindOptions, durationUnitOptions } = props;

  const getKindLabel = value => {
    const kind = kindOptions.find(o => o.value === value);
    return kind ? kind.text : undefined;
  };
  const getDurationUnitLabel = value => {
    const durationUnit = durationUnitOptions.find(o => o.value === value);
    return durationUnit ? durationUnit.text : undefined;
  };
  if (Array.isArray(loans))
    return (
      <Fragment key="loan-summary">
        {loans.map((c, k) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={k} className="row">
            <span className="header">#{k + 1}</span>
            {c.kind ? (
              <>
                <span className="label">{strings['block.loan.field.kind.label']}</span>
                <span className="item">{getKindLabel(c.kind)}</span>
              </>
            ) : undefined}
            {c.amount ? (
              <>
                <span className="label">{strings['block.loan.field.amount.label']}</span>
                <span className="item">
                  <CurrencyNumberFormat value={c.amount} displayType="text" />
                </span>
              </>
            ) : undefined}
            {c.rate ? (
              <>
                <span className="label">{get(strings, 'block.loan.field.rate.label')}</span>
                <span className="item">{round(c.rate * 100, 2)}%</span>
              </>
            ) : undefined}
            {c.duration ? (
              <>
                <span className="label">{strings['block.loan.field.duration.label']}</span>
                <span className="item">
                  {c.duration} {getDurationUnitLabel(c.duration_unit)}
                </span>
              </>
            ) : undefined}
          </div>
        ))}
      </Fragment>
    );
  return undefined;
};

SummaryLoan.propTypes = {
  loans: PropTypes.any.isRequired, // eslint-disable-line
  strings: PropTypes.any.isRequired, // eslint-disable-line
  kindOptions: PropTypes.array, // eslint-disable-line
  durationUnitOptions: PropTypes.array, // eslint-disable-line
};

SummaryLoan.defaultProps = {
  kindOptions: [],
};

export default SummaryLoan;
